// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p7-8";
export var editMode = "_p7-3";
export var headerRow = "_p7-a";
export var headerTitle = "_p7-b";
export var product = "_p7-1";
export var productDetails = "_p7-5";
export var productDivider = "_p7-7";
export var productImage = "_p7-2";
export var productInfo = "_p7-4";
export var productTitle = "_p7-6";
export var strikethrough = "_p7-9";
export var upsellProductsCard = "_p7-0";